import { render, staticRenderFns } from "./IconExpert.vue?vue&type=template&id=d0f0a078&scoped=true&"
import script from "./IconExpert.vue?vue&type=script&lang=js&"
export * from "./IconExpert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f0a078",
  null
  
)

export default component.exports